import { ActionFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { client } from '../../../../../../gql/client';
import { SAVE_ACCIDENT } from '../../../../../../gql/mutations/accidents';

/**
 * Bloque C-9: edición rápida de Accident desde el Accidents tab del
 * WorkOrderDetailed. Antes hasta 6 mutations Promise.all (UPDATE_ORDER +
 * UPDATE_ORDER_RELATIONSHIPS + UPDATE_ACCIDENT_ORDER + UPDATE_ACCIDENT_ORDER_RELATIONSHIPS
 * + UPDATE_ORDER + UPDATE_ORDER_RELATIONSHIPS de sync). Ahora 1 sola
 * SAVE_ACCIDENT con `id` (update path) — backend sincroniza Order ↔ Accident
 * coherentemente vía `$transaction`.
 */
export const AccidentNewWorkOrderDetailed: ActionFunction = async ({
  request,
}) => {
  const formData = await request.formData();
  const pkInit = formData.get('pkInit');
  const pkEnd = formData.get('pkEnd');
  const description = formData.get('description');
  const notes = formData.get('notes');
  const date = formData.get('date');
  const capitol = formData.get('capitol');
  const subCapitol = formData.get('subCapitol');
  const concession = formData.get('concession');
  const road = formData.get('road');
  const modelTypeId = formData.get('modelTypeId');
  const margin = formData.get('margin');
  const direction = formData.get('direction');
  const lane = formData.get('lane');
  const track = formData.get('track');
  const predefine = formData.get('predefine');
  const classification = formData.get('classification');

  const pkInitSplit = pkInit?.toString().replace(/ /g, '').split('+');
  const pkEndSplit = pkEnd?.toString().replace(/ /g, '').split('+');

  try {
    await client.mutate({
      mutation: SAVE_ACCIDENT,
      variables: {
        input: {
          id: modelTypeId as string,
          ...(date && { registerInitDate: date as string }),
          ...(description && { description: description as string }),
          ...(notes && { notes: notes as string }),
          ...(pkInit && {
            pkInitKm: Number(pkInitSplit?.[0]),
            pkInitMeter: Number(pkInitSplit?.[1]),
          }),
          ...(pkEnd && {
            pkEndKm: Number(pkEndSplit?.[0]),
            pkEndMeter: Number(pkEndSplit?.[1]),
          }),
          ...(track && { track: track as string }),
          ...(margin && { margin: margin as string }),
          ...(direction && { direction: direction as string }),
          ...(lane && { lane: lane as string }),
          ...(concession && { concessionId: concession as string }),
          ...(road && { roadId: road as string }),
          ...(capitol && { capitolId: capitol as string }),
          ...(subCapitol && { subCapitolId: subCapitol as string }),
          ...(classification && { classification: classification as string }),
          ...(predefine && { predefinedOrderId: predefine as string }),
        },
      },
    });
    return null;
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Accident updated - error updating:', err);
  }
  return null;
};
